"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerPlayButton = void 0;
var React = require("react");
var PodcastPlayerPlayButton = function (_a) {
    var isPlaying = _a.isPlaying, isEnded = _a.isEnded, audioRef = _a.audioRef, orderOnPage = _a.orderOnPage, setIsEnded = _a.setIsEnded;
    var togglePlay = React.useCallback(function () {
        var audio = audioRef.current;
        if (!audio)
            return;
        if (audio.paused) {
            var customEvent = new CustomEvent('pausePlayer', {
                detail: { playedPlayerOrder: orderOnPage },
            });
            window.dispatchEvent(customEvent);
            setIsEnded(false);
            audio.play();
        }
        else {
            audio.pause();
        }
    }, [audioRef, orderOnPage, setIsEnded]);
    return (React.createElement("button", { className: "podcast-player__play-btn flex-center size-11 text-while bg-brand-primary rounded-full", onClick: togglePlay }, isPlaying ? (React.createElement("span", { className: "icon icon-pause text-inverse" })) : (React.createElement(React.Fragment, null, isEnded ? (React.createElement("span", { className: "icon icon-refresh text-xl text-inverse" })) : (React.createElement("svg", { className: "icon icon-play text-[26px] translate-x-[2px] text-inverse", width: "20px", height: "20px", viewBox: "-3 0 28 28", version: "1.1" },
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(-419.000000, -571.000000)", fill: "currentColor" },
                React.createElement("path", { d: "M440.415,583.554 L421.418,571.311 C420.291,570.704 419,570.767 419,572.946 L419,597.054 C419,599.046 420.385,599.36 421.418,598.689 L440.415,586.446 C441.197,585.647 441.197,584.353 440.415,583.554" })))))))));
};
exports.PodcastPlayerPlayButton = PodcastPlayerPlayButton;
